const apiUrl = process.env.NEXT_PUBLIC_API_URL;
const loginUrl = process.env.NEXT_PUBLIC_LOGIN_URL;

export default { apiUrl, loginUrl };
